// extracted by mini-css-extract-plugin
module.exports = {"button":"SliderButton_button__EpOCT","disabled":"SliderButton_disabled__ihdZT"};